/**
 * Vue: Back in stock
 * ------------------------------------------------------------------------------
 * - Uses inline template.
 *
 */

function BackInStock () {
    const selectors = {
        form: "backInStockForm",
        input: 'BackInStockInput',
        submit: "BackInStockSubmit"
    }
    const elements = {
        form_element: document.getElementById(selectors.form),
        input_element: document.getElementById(selectors.input),
        submit_element: document.getElementById(selectors.submit)
    }

    const values = {
        emailValue: elements.input_element.value,
        variantId: elements.form_element.getAttribute("data-variant-id"),
        variantAvailable: elements.form_element.getAttribute("data-variant-available"),
        productId: elements.form_element.getAttribute("data-product-id")
    }

    const modifiers = {
        success: "success",
        error: "error",
    }

    const initEventListeners = () =>{
        elements.form_element.addEventListener("submit", (event)=>{
            event.preventDefault();
            if(getBackInStockDisabled()) {
                handleBackInStockSubmit();
            };
        })

        elements.input_element.addEventListener('focusin', ()=>{
            elements.form_element.querySelector('.back-in-stock__inputs').classList.add('active')
        })

        elements.input_element.addEventListener('focusout', ()=>{
            elements.form_element.querySelector('.back-in-stock__inputs').classList.remove('active')
        })

        elements.input_element.addEventListener('input', ({target})=>{
            const value = target.value;
            const isDisabled = elements.submit_element.hasAttribute('disabled')
            if(value.length && isDisabled) {
                elements.submit_element.removeAttribute('disabled')
            } else if (!value.length && !isDisabled) {
                elements.submit_element.setAttribute('disabled', true)
            }
        })
    }

    const getBackInStockDisabled = () => {
        const emailValue = elements.input_element.value;
        return ( values.variantId.length && values.variantAvailable === 'false' && emailValue.length)
    }

    const handleBackInStockSubmit = () => {
        const emailValue = elements.input_element.value;
        if (!emailValue) {
            return
        }
        
        const data = {
            // eslint-disable-next-line id-length
            a: window.theme.api.klaviyo,
            email: emailValue,
            // Subscribe to newsletter list ID, optional.
            // g: 'list_id',
            platform: 'shopify',
            product: values.productId,
            // eslint-disable-next-line babel/camelcase
            subscribe_for_newletter: false,
            variant: values.variantId
        }
        const formData = new FormData()

        Object.keys(data).forEach((key) => {
            formData.append(`${key}`, `${data[key]}`)
        })
        fetch(
            'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',
            {
                body: formData,
                credentials: 'omit',
                method: 'POST',
                mode: 'no-cors',
                referrer: document.URL,
                referrerPolicy: 'no-referrer-when-downgrade'
            }
        )
            .then(() => {
                onSuccess()
            })
            .catch((error) => {
                onError()
                throw new Error('Failed to submit back in stock', error)
            })
    }

    const onSuccess = () => {
        elements.form_element.classList.remove(modifiers.error)
        elements.form_element.classList.add(modifiers.success)
    }

    const onError = () => {
        elements.form_element.classList.add(modifiers.error)
        elements.form_element.classList.remove(modifiers.success)
    }

    const onInit = () => {
        initEventListeners();
        if(getBackInStockDisabled()) {
            handleBackInStockSubmit();
        }
    }
    onInit();
}

document.addEventListener("DOMContentLoaded", () => {
    const wrapper = document.querySelector('.product-form__back-in-stock');
        if (wrapper) {
            BackInStock();
        }
    }
);


